export default __webpack_public_path__ + "static/media/nft12.32cb1349.png";